<template lang="pug">
  
  .row
    .col-lg-5
      //-----------------------------------------------
      //- If NOT ELLIGIBLE FPX, then show mesage
      //-----------------------------------------------
      template(v-if="!currentUser.fpxEligible || !hasFpxEligibleAccounts")
        MessageBar(type="warning", :withIcon="false")
          | FPX Direct Transfer payment method is currently only available to <strong>Cash Management Account (CMA)</strong> and <strong>Cash Management-I Account (CMA-I)</strong> accounts only.


      //-----------------------------------------------
      //- If elligible, then show the form
      //-----------------------------------------------
      template(v-else)
        .form--group
          label Client Code
          b-form-select(v-model="ropForm.clientCode", :disabled="isSingleClientCode")
            option(v-for="acc in currentUser.fpxEligibleAccounts" :value="acc.clientCode") {{ acc.clientCode }} - {{ acc.productType }}

        .form--group(v-if="!firstTimeEmail")
          label Email Address
          b-form-select(v-model="ropForm.email", @change="EMPTY_FIELD('emailNew')")
            option(v-for="email in currentUser.emails" :value="email") {{ email }}
            option(disabled) ---------------------
            option(value="_0_") Use another email address

        .form--group(v-if="ropForm.email === '_0_'")
          label
            span(v-if="firstTimeEmail") Email Address
            span(v-else) Enter new email address
          b-form-input(type="text", v-model='ropForm.emailNew', placeholder="Example: username@gmail.com", @blur="$v.ropForm.emailNew.$touch")
          .form--note.form--note_warning(v-if="$v.ropForm.emailNew.$error") Please enter a valid email address

        .form--group(v-if="!firstTimePhone")
          label Phone Number
          b-form-select(v-model="ropForm.phone" @change="EMPTY_FIELD('phoneNew')")
            option(v-for="phone in currentUser.phones" :value="phone") {{ phone }}
            option(disabled) ---------------------
            option(value="_0_") Use another phone number

        .form--group(v-if="ropForm.phone === '_0_'")
          label 
            span(v-if="firstTimePhone") Phone Number
            span(v-else) Enter new phone number
          b-form-input(type="text", v-model='ropForm.phoneNew', placeholder="Example: 01112345678", @blur="$v.ropForm.phoneNew.$touch")
          .form--note.form--note_warning(v-if="$v.ropForm.phoneNew.$error") Accepted format: 01112345678

        .form--group
          label Amount (RM)
          b-form-input(type="number", v-model.number='ropForm.amount', placeholder="Enter Amount (RM)", @input="$v.ropForm.amount.$touch")
          .form--note.form--note_warning(v-if="$v.ropForm.amount.$error") This field is required (maximum 2 decimal places)

        .form--group
          button.btn.btn-info(@click="OPEN_REMINDER_MODAL", :disabled="$v.$invalid")
            span.btn__standard Proceed to Payment Portal
          
    .col-lg-7
      FPXTnC


    //---------------------------------------
    //- Modal for when fpx is down
    //- Just turn ui_controls.showFPXDownModal = true
    //---------------------------------------
    b-modal(v-model="ui_controls.showFPXDownModal", hide-footer, hide-header, no-close-on-esc, no-close-on-backdrop)
      .modal--container
        p.text__uppercase: strong E-Payment service unavailable
        p.text--color_grey We would like to inform that the FPX Service is currently experiencing downtime. E-Payment service will be affected. 
        p.text--color_grey Do contact your Dealer's Representative / Branch Representative if you require any assistance.
        p.text--color_grey Thank you and apologies for any inconvenience caused.
        button.button.button-neutral.button_standard(@click="$router.go(-1)")
          font-awesome-icon(icon="arrow-left")
          span.mar_l--5 Go Back


    //---------------------------------------
    //- Reminder / Confirmation Modal
    //---------------------------------------
    b-modal(ref='paymentReminderModal', hide-footer, hide-header)
      .modal--container
        h5: strong.bold__semi Reminder
        .pad_t--10
          .text--size_18.text--color_secondary.mar_b--20 
            strong E-Payment from a <u><strong class="bold__black">third party</strong></u> account will not be accepted.
          MessageBar(type="neutral", :withIcon="false")
            .heading--h4.pad_b--10: strong Transfer Limit
            ul.list--unordered.list--unordered_circle
              li
                strong Retail
                br
                | Minimum limit per transaction = RM1.00
                br
                | Maximum limit per transaction = RM30,000*
              li
                strong Corporate
                br
                | Minimum limit per transaction = RM2.00
                br
                | Maximum limit per transaction = RM1,000,000*
            .pad_t--15
              | *The above limit is subject to your internet banking limit with your preferred bank, whichever is lower.

        .pad_t--30
          .row
            .col-6
              button.btn.btn-light(@click="$refs.paymentReminderModal.hide()")
                span.btn__standard Go Back

            .col-6.text-right
              LoadingIcon(class="mar_r--10" :shown="ui_controls.isDisabled", color="secondary")

              button.btn.btn-info(@click="SUBMIT_FPX_FORM", :disabled="ui_controls.isDisabled")
                span.btn__standard Proceed

              .form--note.form--note_warning(v-if="ui_controls.requestError") {{ ui_controls.requestError }}
        

    form(name="frmPayment", method="post", :action="eGhlForm.url", v-html="eGhlForm.htmlBody")


</template>



<script>
  import { mapState } from 'vuex';

  import Loading from "../components/Loading";
  import LoadingIcon from "../components/LoadingIcon";
  import MessageBar from "../components/MessageBar";
  import FPXTnC from "../components/FPXTnC";

  import { validationMixin } from 'vuelidate';
  import { required, requiredIf, email } from 'vuelidate/lib/validators';
  import requestHandlers from '@/mixins/requestHandlers';

  export default  {
    name: 'FPXEPayment',
    mixins: [validationMixin, requestHandlers],
    components: {
      Loading,
      LoadingIcon,
      MessageBar,
      FPXTnC
    },


    data() {
      return {
        ui_controls: {
          isDisabled: false,
          requestError: '',
          showFPXDownModal: false,
        },

        ropForm: {
          clientCode: '',
          email: '',
          emailNew: '',
          phone: '',
          phoneNew: '',
          amount: '0',
        },

        eGhlForm: {
          url: process.env.VUE_APP_EGHL_URL,
          htmlBody: '',
        }
      }
    },


    computed: {
      ...mapState('auth', [
        'currentUser'
      ]),

      hasFpxEligibleAccounts() {
        return this.currentUser.fpxEligibleAccounts.length > 0;
      },
      isSingleClientCode() {
        return this.currentUser.fpxEligibleAccounts.length === 1;  
      },
      firstTimeEmail() {
        return this.currentUser.emails.length === 0;
      },
      firstTimePhone() {
        return this.currentUser.phones.length === 0;
      }
    },


    methods: {
      OPEN_REMINDER_MODAL() {
        this.$refs.paymentReminderModal.show();
      },

      CREATE_FPX_FORM_PAYLOAD() {
        let _payload = {};

        Object.keys(this.ropForm).forEach(key => {
          let value = this.ropForm[key];

          if(key === "emailNew" || key === "phoneNew") {
            return;
          }

          if((key === "email" || key === "phone") && this.ropForm[key] === "_0_") {
            value = this.ropForm[`${key}New`];
          }

          _payload[key] = value;
        })

        return _payload;
      },

      async SUBMIT_FPX_FORM() {
        this.ui_controls.isDisabled = true;
        this.ui_controls.requestError = false;
      
        let params = this.CREATE_FPX_FORM_PAYLOAD();

        try {
          let response = await this.$axios.get(`/payment/request`, { params });

          // If response is not 200, throw error
          if(response.status !== 200) {
            throw new Error('An error has occured.');
          }

          // 1. Generate the (hidden) inputs inside the eGhl form
          // 2. Submit the eGhl form
          this.GENERATE_EGHL_FORM_BODY(response.data);
          this.SUBMIT_EGHL_FORM();

        } catch(err) {
          let { response } = err;

          if(!response) {
            this.HANDLE_ERROR_GENERIC(err);
            return;
          }

          if(response.status === 400 && response.data) {
            this.ui_controls.requestError = response.data;
          }
        } finally {
          this.ui_controls.isDisabled = false;
        }
      },

      GENERATE_EGHL_FORM_BODY(data) {
        let _htmlString = '';

        Object.keys(data).forEach(key => {
          let _key = key;
          let _value = data[key];

          if(_value == null || _value === "") {
            return;
          }

          _htmlString += `<input type="hidden" name="${_key}" value="${_value}" />\n`;
        });

        _htmlString += `<input id="js--eghl-form" type="submit" value="SUBMIT" class="hidden">`

        this.eGhlForm.htmlBody = _htmlString;
      },

      SUBMIT_EGHL_FORM() {
        this.$nextTick(function () {
          this.$jQuery("#js--eghl-form").trigger('click');
        })
      },

      EMPTY_FIELD(key) {
        if(!key) { 
          return;
        }
        this.ropForm[key] = '';
        this.$v.ropForm[key].$reset();
      },

      SET_INITIAL_FORM_VALUES() {
        let { fpxEligibleAccounts, phones, emails } = this.currentUser;

        // Set client code
        if(fpxEligibleAccounts.length) {
          this.ropForm.clientCode = fpxEligibleAccounts[0].clientCode;
        }

        // set email
        if(this.firstTimeEmail) {
          this.ropForm.email = '_0_';
        } else {
          this.ropForm.email = emails[0];
        }

        // set phone
        if(this.firstTimePhone) {
          this.ropForm.phone = '_0_';
        } else {
          this.ropForm.phone = phones[0]; 
        }
      }
    },


    created() {
      this.SET_INITIAL_FORM_VALUES();
    },


    validations: {
      ropForm: {
        clientCode: {
          required
        },
        email: {
          required,
        },
        emailNew: {
          required: requiredIf(nestedModel => {
            return nestedModel.email === "_0_";
          }),
          email
        },
        phone: {
          required,
        },
        phoneNew: {
          required: requiredIf(nestedModel => {
            return nestedModel.phone === "_0_";
          }),
          isValidPhoneNumber: function(value) {
            if(value === "") {
              return true;
            }
            return /^\d{8,12}$/.test(value);
          },
        },
        amount: {
          required,
          isValidAmount: function(value) {
            return /^[1-9]\d*(\.\d{1,2})?\s*$/.test(value);
          }
        },
      },
    },
  }
</script>




<style lang="scss">

</style>